import ModalConfirm, { IModalConfirmMethods } from "./ModalConfirm";

export default ModalConfirm;
export type { IModalConfirmMethods };
